import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { CreateUpdateUserHQLocationDashBoard } from "../../../domain/useages/user-hq-location-dashboard/create-update-user-hq-location-dashboard";
import { RemoteCreateUpdateUserHQLocationDashBoard } from "../../../data/usecases/user-hq-location-dashboard/remote-create-update-user-hq-location-dashboard";

export interface CreateUpdateUserHQLocationDashBoardInterface {
  
    CreateUpdateUserHQLocationDashBoardState: FetchState;
    createUpdateUserHQLocationDashBoard: Function;
}

const initialStates = {
  CreateUpdateUserHQLocationDashBoardState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useCreateUpdateUserHQLocationDashBoardSlice: StateCreator<
  CreateUpdateUserHQLocationDashBoardInterface
> = (set) => ({
  ...initialStates,
  createUpdateUserHQLocationDashBoard: async (
    payload: CreateUpdateUserHQLocationDashBoard.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteCreateUpdateUserHQLocationDashBoard =
      new RemoteCreateUpdateUserHQLocationDashBoard(
        `${BASE_URL}${Endpoints.CREATE_UPDATE_USER_HQ_LOCATION_DASHBOARD}`,
        axiosHttpClient
      );

    set(() => ({
      CreateUpdateUserHQLocationDashBoardState: FetchState.LOADING,
    }));
    let result = await remoteCreateUpdateUserHQLocationDashBoard.add(payload);
    return result;
  },
});
